import { render, staticRenderFns } from "./ArrearsEnquiryDetail.vue?vue&type=template&id=b9cc2624&scoped=true"
import script from "./ArrearsEnquiryDetail.vue?vue&type=script&lang=js"
export * from "./ArrearsEnquiryDetail.vue?vue&type=script&lang=js"
import style0 from "./ArrearsEnquiryDetail.vue?vue&type=style&index=0&id=b9cc2624&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9cc2624",
  null
  
)

export default component.exports